import styled from "styled-components";
import { Link } from "react-router-dom";
// Componentes personalizados
import { BotaoFaleConosco, BotaoAreaCliente } from "../Botoes";
// Imagens
import LogoSifatAzulHorizontal from "../../assets/imagens/Logomarca Sifat 2019 - Azul Horizontal.png";
// Bootstrap
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import NavDropdown from "react-bootstrap/NavDropdown";
import ModalAvisos from "../ModalAvisos";

const StyledLogoSifatAzulHorizontal = styled.img`
  width: 5em;
  height: auto;
`;

const LinkStyled = styled(Link)`
  text-decoration: none;
  color: #1b355e;
  font-weight: var(--regular-weight);

  &:hover {
    color: #1b355e;
  }

  &:link {
    color: #1b355e;
  }

  &:visited {
    color: #1b355e;
  }
`;

const DropItem = styled(({ to, children, ...props }) => (
  <NavDropdown.Item as={LinkStyled} to={to} {...props}>
    {children}
  </NavDropdown.Item>
))``;

const NavStyled = styled(Nav)`
  display: flex;
  flex-direction: column;
  gap: 2em;

  @media screen and (min-width: 993px) {
    align-items: center;
  }
`;

const ContainerStyled = styled(Container)`
  max-width: var(--max-section-w);
`;

function LinksDropdown() {
  return (
    <NavDropdown id="nav-dropdown" title="Soluções">
      <DropItem to={`/waychef`}>Waychef - ERP + PDV Food Service</DropItem>

      <DropItem to={`/waymenu`}>Waymenu - Delivery e Cardápio Digital</DropItem>

      <DropItem to={`/waypay`}>Waypay - Autopagamento</DropItem>

      <DropItem to={`/wayservice`}>Wayservice - Autoatendimento</DropItem>

      <DropItem to={`/waiter`}>Waiter - Restaurantes e Similares</DropItem>

      <DropItem to={`/efex-pdv`}>Efex - PDV Mercados e casa de carnes</DropItem>

      <DropItem to={`/sifat-lumien`}>Lumien - Posto de combustível</DropItem>

      <DropItem to={`/sifat-flutt`}>Flutt - PDV Varejo</DropItem>
    </NavDropdown>
  );
}

export default function Header() {
  return (
    <Navbar key={"lg"} expand={"lg"} className="bg-body-tertiary" sticky="top">
      <ContainerStyled fluid>
        <Navbar.Brand as={Link} to="/">
          <StyledLogoSifatAzulHorizontal
            src={LogoSifatAzulHorizontal}
            alt="Logo Sifat"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${"md"}`} />

        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-${"md"}`}
          aria-labelledby={`offcanvasNavbarLabel-expand-${"md"}`}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${"md"}`}>
              SIFAT
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body className={"justify-content-end"}>
            <NavStyled>
              <LinkStyled to={`/`}>Home</LinkStyled>
              <LinkStyled to={`/quem-somos-sifat`}>Sobre nós</LinkStyled>
              <LinksDropdown />
              <LinkStyled to={`/integrador`}>Seja um parceiro</LinkStyled>

              {<BotaoFaleConosco />}
              {<BotaoAreaCliente />}
              {<ModalAvisos />}
            </NavStyled>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </ContainerStyled>
    </Navbar>
  );
}
